import { render, staticRenderFns } from "./UserFullDetails.vue?vue&type=template&id=303e0826&scoped=true&"
import script from "./UserFullDetails.vue?vue&type=script&lang=js&"
export * from "./UserFullDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserFullDetails.vue?vue&type=style&index=0&id=303e0826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303e0826",
  null
  
)

export default component.exports